import { Toaster } from 'sonner'
import { AppRouter, AuthInit } from '@/routes'
import { SocketProvider } from '@/providers/SocketProvider'
import { useUIStore } from '@/stores/useUIStore'
import { OrganizationBrandTheme } from '@/features/organization/components/OrganizationBrandTheme'
import { StandaloneErrorBoundary } from '@/components/common/ErrorBoundary'
import { AppCrashFallback } from '@/components/common/AppCrashFallback'
import { MaintenanceGate } from '@/features/maintenance/components/MaintenanceGate'

function App(): React.ReactElement {
  const theme = useUIStore((s) => s.theme)

  return (
    <>
      <Toaster
        position="top-center"
        theme={theme}
        richColors
        toastOptions={{
          classNames: {
            toast:
              '!rounded-lg !border !shadow-lg !font-sans dark:!bg-gray-800 dark:!border-gray-600 dark:!text-gray-100',
            title: '!font-medium',
            description: 'dark:!text-gray-300',
            success:
              '!border-success/50 dark:!border-success/40 [&_[data-icon]]:!text-success',
            error:
              '!border-danger/50 dark:!border-danger/40 [&_[data-icon]]:!text-danger',
            warning:
              '!border-warning/50 dark:!border-warning/40 [&_[data-icon]]:!text-warning',
          },
        }}
      />
      {/* Outermost net: catches crashes in providers, auth bootstrap, and the
          router itself, where routing-aware fallbacks are not yet available. */}
      <StandaloneErrorBoundary
        fallback={(error, reset) => <AppCrashFallback error={error} reset={reset} />}
      >
        {/* Outside AuthInit on purpose: a locked-out user cannot sign in, so the
            explanation has to reach them before authentication is attempted. */}
        <MaintenanceGate>
          <AuthInit>
            <OrganizationBrandTheme />
            <SocketProvider>
              <AppRouter />
            </SocketProvider>
          </AuthInit>
        </MaintenanceGate>
      </StandaloneErrorBoundary>
    </>
  )
}

export default App
